import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import React from "react";

const Container = styled(Grid)`
	position: relative;
	display: flex;
	align-items: center;
	width: fit-content;
	// max-width: 100%;
    max-width: 800px;
	margin: 0 auto 10px;
	background-color: white;
	border-radius: 20px;
	padding: 20px 30px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 1);
`;

const HeroSection = () => {
	return (
		<Container container alignItems='center'>
			<Grid item>
				<img
					src='/pictures/profile-pic.png'
					alt='Eric'
					height={80}
					width={80}
					style={{
						marginRight: 20,
					}}
				/>
			</Grid>
			<Grid item xs>
				<Grid container direction='column' justifyContent='center'>
					<Grid item sx={{ pb: 1 }}>
						<Typography variant='h1' fontWeight={600}>
							Heyoo!
						</Typography>
					</Grid>
					<Grid item sx={{ pb: 1 }}>
						<Typography variant='h5' sx={{ fontSize: "1.1rem" }}>
							I&apos;m Eric. An engineer by trade with a passion for all things product design, development, and customer experience.
						</Typography>
					</Grid>
                    <Grid item>
						<Typography variant='h5' sx={{ fontSize: "1.1rem" }}>
							Take a look around to check out some projects I&apos;ve worked on as well as companies I&apos;ve worked for.
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

export default HeroSection;
